export const environment = {
  production: false,
  LOONY_STAKING_ADDRESS: '0x4c7E520B1449c766cd1AaD5230131Ff1FcE3c49F' as `0x${string}`,
  LOONY_TOKEN_ADDRESS: '0x4a937122B1D419b506ab6668F7C1f562dD113656' as `0x${string}`,
  PROJECT_ID :'05312b01f097b2eae72a1e5039e5c52e'

};
